import TextField from "@mui/material/TextField";
import type { ChangeEvent } from "react";
import type { TenantEditableColumn, TenantItem } from "../../types/tenant";

type TextFieldValidateProps = {
  input: TenantItem;
  column: TenantEditableColumn;
  changedValue: (value: string) => void;
};

export default function TextFieldValidate({
  input,
  column,
  changedValue,
}: TextFieldValidateProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    changedValue(e.target.value);
  };

  const value = input[column];
  const defaultValue = typeof value === "string" ? value : String(value ?? "");

  return (
    <TextField
      size="small"
      defaultValue={defaultValue}
      sx={{ pointerEvents: "auto" }}
      onChange={handleChange}
    />
  );
}
